export interface ActionType{
  title: string;
  tipo: string;
}

export const UPDATE:ActionType = {
  title:"Editar Maestro Validación",
  tipo:"U"
}

export const CREATE: ActionType = {
  title:"Nuevo Maestro Validación",
  tipo:"I"
}
